import { Button, Icon, PageWrapper } from '@/shared'
import { EIcons } from '@App/types/iconType'

import style from './Control.module.scss'

interface IProps {
    onAddFaq: () => void
}

export const Control = (props: IProps) => {
    const { onAddFaq } = props
    return (
        <PageWrapper>
            <div className={style.container}>
                <Button onClick={onAddFaq}>
                    <div>
                        <Icon iconName={EIcons.PLUS} color='#fff' />
                        <span>Добавить вопрос</span>
                    </div>
                </Button>
            </div>
        </PageWrapper>
    )
}
